import { render, staticRenderFns } from "./MiniStatsIconCard.vue?vue&type=template&id=020d23ab&scoped=true&"
import script from "./MiniStatsIconCard.vue?vue&type=script&lang=js&"
export * from "./MiniStatsIconCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020d23ab",
  null
  
)

export default component.exports